import { useContext } from "react";
import { ModalContext } from "../utils/constants";

export function useModal() {
  return useContext(ModalContext);
} 